import { useMutation, UseMutationResult, useQuery, QueryResult } from '@eika-infrastruktur/react-query';
import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import type { ActivationDeviceId, SigningMethodRequest, SigningMethodResponse } from '../generated-types';
import { getSigningMethod, saveSigningMethod } from '../services/selectSigningMethodService';

const useSigningMethod = (deviceId: string | undefined): QueryResult<SigningMethodResponse> =>
    useQuery({
        queryKey: ['signing-method'],
        queryFn: () => getSigningMethod({ value: deviceId! }),
        enabled: !!deviceId,
    });

export const useUpdateSigningMethod = (
    deviceId: ActivationDeviceId,
): UseMutationResult<void, RequestExceptionWithResponse, SigningMethodRequest> =>
    useMutation<void, RequestExceptionWithResponse, SigningMethodRequest>({
        mutationKey: ['signing-method-update'],
        mutationFn: (signingMethodRequest) => saveSigningMethod(deviceId, signingMethodRequest),
    });

export default useSigningMethod;
